
import React, { Component } from 'react'
import ProfileAppointedAuction from './ProfileContainers/ProfileAppointedAuctionCard'
import ProfileAuctionCard from './ProfileContainers/ProfileAuctionCard'
import ProfileExpiredAuction from './ProfileContainers/ProfileExpiredAuctionCard'
import ProfileLotCard from './ProfileContainers/ProfileLotCard'
import ProfileMeetingCard from './ProfileContainers/ProfileMeetingCard'

const getComponent = {
    "lotCard": ProfileLotCard,
    "auction": ProfileAuctionCard,
    "agreement": ProfileMeetingCard,
    "expired-auction": ProfileExpiredAuction,
    "agreed": ProfileAppointedAuction,

}


export default class ProfileWrapper extends Component {
    render() {

        const getModifiedLinkClass = ( linkName ) => (
            linkName === this.props.active ? 'Profile__nav-link Profile__nav-link_active' : "Profile__nav-link"
        )

        const Component = getComponent[this.props.switch.currentData.type]

        return (
            <div className='Profile'>
                <div className='FundForm Profile__container'>
                    <div className='Profile__left'>
                        <div className='Profile__left-text'>
                            {this.props.title && <p className='Profile__left-title'>{this.props.title}</p>}
                            {this.props.text}
                            {this.props.title && <p className='Profile__left-hashtag'>#КаждаяВстречаИмеетЗначение</p>}
                        </div>
                    </div>
                    <div className='Profile__right'>
                        <div className='Profile__nav'>
                        <a className={getModifiedLinkClass("about")} href='/profile'>Обо мне</a>
                        <a className={getModifiedLinkClass("auctions")} href='/lots'>Мои аукционы</a>
                        <a className={getModifiedLinkClass("meetings")} href='/personvisits'>Мои встречи</a>
                        </div>
                        <div className='Profile__form'>
                            {
                                !this.props.switch.status
                                ?
                                this.props.children
                                :
                                <Component data={this.props.switch.currentData.data} back={this.props.back} user={this.props.user}/>
                            }
                        </div>  
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileWrapper.jsx